import React from 'react';
import { motion } from 'framer-motion';
import { useGeneralHooks } from '../../../../Hooks/hooks';
import { DeliveryImage, FoodPackage, ReserveImage } from '../../../../Assets/Images';
import styles from './serviceSections.module.scss';

const Section: React.FC<{
  alt: 'alt1' | 'alt2';
  title: string;
  text: string;
  image: string;
  features: string[];
}> = ({ alt, title, text, image, features }) => {
  return (
    <motion.div
      className={`${styles.row} ${styles[alt]}`}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
    >
      <div className={styles.imageContainer}>
        <img src={image} alt={title} className={styles.serviceImage} />
        <div className={styles.imageOverlay}>

        </div>
      </div>
      <div className={styles.content}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.subtitle}>{text}</p>
        <ul className={styles.featuresList}>
          {features.map((feature, index) => (
            <li key={index} className={styles.featureItem}>
              <span className={styles.checkmark}>✓</span>
              {feature}
            </li>
          ))}
        </ul>
      </div>
    </motion.div>
  );
};

const ServiceSections: React.FC = () => {
  const { t, navigate } = useGeneralHooks();

  return (
    <div className={styles.sections}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>
          {t('Main.Services.Title', 'Our Services')}
        </h2>
        <p className={styles.sectionSubtitle}>
          {t('Main.Services.Subtitle', 'Everything you need to manage your restaurant business')}
        </p>
      </div>

      <Section
        alt="alt1"
        title={t('Main.Services.Delivery.Title', 'Delivery Management')}
        text={t('Main.Services.Delivery.Text', 'Manage all your delivery orders from one centralized dashboard.')}
        image={DeliveryImage}
        features={[
          t('Main.Services.Delivery.Feature1', 'Order tracking & management'),
          t('Main.Services.Delivery.Feature2', 'Driver assignment & routing'),
          t('Main.Services.Delivery.Feature3', 'Real-time order updates')
        ]}
      />
      <Section
        alt="alt2"
        title={t('Main.Services.Pickup.Title', 'Pickup Management')}
        text={t('Main.Services.Pickup.Text', 'Streamline pickup orders and optimize your kitchen workflow.')}
        image={FoodPackage}
        features={[
          t('Main.Services.Pickup.Feature1', 'Order preparation tracking'),
          t('Main.Services.Pickup.Feature2', 'Customer notification system'),
          t('Main.Services.Pickup.Feature3', 'Pickup time optimization')
        ]}
      />
      <Section
        alt="alt1"
        title={t('Main.Services.Reservation.Title', 'Table Management')}
        text={t('Main.Services.Reservation.Text', 'Handle table reservations and optimize your seating capacity.')}
        image={ReserveImage}
        features={[
          t('Main.Services.Reservation.Feature1', 'Table availability tracking'),
          t('Main.Services.Reservation.Feature2', 'Reservation scheduling'),
          t('Main.Services.Reservation.Feature3', 'Customer management system')
        ]}
      />

    </div>
  );
};

export default ServiceSections;
